import { Card, Skeleton, Divider } from "@mui/material";

const TicketComponentSkeleton = () => {
    return (
        <div>
            <Card sx={{ display: "flex", flexDirection: "column", padding: "20px", width: "100%", height: "100%", gap: "10px", borderRadius: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "10px" }}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton variant="rectangular" height={40} sx={{ flexGrow: 1 }} />
                    <Skeleton variant="rectangular" width={150} height={40} />
                    <Skeleton variant="circular" width={40} height={40} />
                </div>

                <Divider variant="fullWidth" sx={{ border: "1px solid" }} />

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width="40%" height={24} />
                    <Skeleton variant="rectangular" width={130} height={36} />
                </div>

                <Skeleton variant="text" width="80%" height={28} />
                <Divider variant="fullWidth" sx={{ border: "1px solid" }} />

                <Skeleton variant="text" width="30%" height={24} />
                <Skeleton variant="rectangular" width="100%" height={100} />

                <Divider variant="fullWidth" sx={{ border: "1px solid" }} />

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width="30%" height={24} />
                    <Skeleton variant="rounded" width={80} height={30} />
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width="30%" height={24} />
                    <Skeleton variant="rounded" width={80} height={30} />
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width="30%" height={24} />
                    <Skeleton variant="text" width="30%" height={24} />
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width="30%" height={24} />
                    <Skeleton variant="text" width="30%" height={24} />
                </div>
            </Card>
        </div>
    );
};

export default TicketComponentSkeleton;